import styled from 'vue-styled-components'
import {FONTS} from '../../constants'

export const GridContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-family: ${FONTS.KNOCKOUT_50_FONT}
`
export const GridItem = styled('svg')`
  margin: 15px;
`

export const BackgroundIsland = styled('path')`
  stroke: #f2f2f2;
  stroke-width: 20px;
  fill: none;
  stroke-linejoin: round;
`